import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import ExpenseAllocation from './ExpenseAllocation';
import PracticalTexts from "../PracticalTexts";
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";
import Document from "./Document";

export default class Expense extends Base {
	constructor(props) {
		super(props);
		this.state = {
			enableDatePicker: false,
			confirmBeforeEsacpe: true,
			caller: props.Caller,
			controllerName: 'expense',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
			barcode: '',
			lastAdjustmentTextId: null,
			uiSettings: this.getUiSettings(),
			pricesAnnouncements: []
		};
		this.inputRefs = [];
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	openPrint() {
		this.showComponents({
			component: <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
				<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closePopupComponent()}></div>
				<div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
					<div className="modal-content">
						<div className="modal-body" style={{ "padding": "0" }}>
							<div className="modal-header modal-header-info">
								<button type="button" className="close" onClick={e => this.closePopupComponent()} aria-label="Close"><span aria-hidden="true">×</span></button>
								<h4 className="modal-title">چاپ</h4>
							</div>
							<div className="modal-body">
								<div className="container-fluid">
									<div className="row">
										<div className="col-sm-12 mb-2">
											<div className="form-group">
												<label for="name" className="title1">عنوان</label><span className="red">*</span>
												<select defaultValue={this.state.printFormat} onChange={e => this.state.printFormat = e.target.value} className="form-control">
													<option value="">استاندارد A4</option>
													<option value="DetailA5">استاندارد A5</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closePopupComponent()}>برگشت</button>
								<button type="submit" onClick={e => this.getPdf(this.state.data.record.id, { type: this.state.data.record.type })} className="btn btn-success">PDF</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		});
	}
	resetRefs() {
		this.inputRefs = [];
	}
	handleKeyDown = (rowIndex, colIndex, e) => {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (e.key === "Enter") {
			e.preventDefault();
			if (colIndex + 1 < colCount) {
				//find first next active input
				if (!row[colIndex + 1]) {
					this.handleKeyDown(rowIndex, colIndex + 1, e);
				}
				else {
					row[colIndex + 1]?.focus();
					if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
				}
			} else if (rowIndex + 1 < rowCount) {
				if (!this.inputRefs[rowIndex + 1][0]) {
					this.handleKeyDown(rowIndex + 1, 1, e);
				}
				else {
					this.inputRefs[rowIndex + 1][0]?.focus();
					if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
				}
			}
		}

		if (e.key === "ArrowDown") {
			e.preventDefault();
			e.preventDefault();
			if (rowIndex + 1 < rowCount) {
				this.inputRefs[rowIndex + 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
			}
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			if (rowIndex - 1 >= 0) {
				this.inputRefs[rowIndex - 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
			}
		}
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.getUiSettingConfigs({ formName: 'expense' });

		this.getData();
	}
	getData() {
		this.httpPost('api/v1/expense/get', {
			id: this.state.id,
		}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {
				window.organizationId = data.global.company.id;
				this.state.data = data;

				this.state.loading = false;
				this.updateFormula();

			} else {
				//this.showErorrMessage(data.message);
				this.setState({
					data: data,
					loading: false,
				});
			}
		});
	}
	selectTextAddjustment(type, id) {
		this.state.lastAdjustmentTextId = id;
		this.removeKeyDown();
		this.showComponents({
			component: <PracticalTexts
				Caller={this}
				Type={type}
				OnSelect="onSelectTextAddjustment"
			/>
		});
	}
	onAllocation(expenseItemId = null) {
		this.removeKeyDown();
		this.showComponents({ component: <ExpenseAllocation Caller={this} Id={this.state.id} ExpenseItemId={expenseItemId} /> });	
	}
	save(e, status) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

		this.httpPost("api/v1/expense/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			number: this.state.data.record.number,
			fromDate: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.fromDate) : this.state.data.record.fromDateString),
			toDate: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.toDate) : this.state.data.record.toDateString),
			total: this.state.data.record.total,
			description: this.state.data.record.description,
			note: this.state.data.record.note,
			status,
			items: this.state.data.record.items,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("دفتر با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			index: defaultIndex == null ? this.state.data.record.items.length + 1 : defaultIndex,
			price: 0,
			description: '',
			accountId: null,
			accountName: '',
			costCenterId: null,
			costCenterName: '',
			costTafsilId: null,
			costTafsilName: '',
		};
	}
	addBlankRow() {
		this.state.data.record.items.push(this.getBlankRow());
	}
	removeRow(id) {
		this.resetRefs();
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.updateFormula();
	}
	copyRow(id) {
		this.resetRefs();
		var clone = null;
		this.state.data.record.items.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].index > startIndex) this.state.data.record.items[i].index++;
		}
		clone.index++;
		this.state.data.record.items.push(clone);
		this.updateFormula();
	}
	upIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii - 1;
			this.state.data.record.items[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii + 1;
			this.state.data.record.items[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	async setBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].id === id) {
				if (
					field == 'costCenterId' || field =='costTafsilId' ||
					field == 'accountId'
				) {
					if (field == 'costCenterId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]['costCenterName'] = value.label;
					}
					if (field == 'costTafsilId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]['costTafsilName'] = value.label;
					}					
					if (field == 'accountId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["accountName"] = value.label;
					}
				} else {
					this.state.data.record.items[i][field] = value;
				}
			}
		}
		this.updateFormula();

		//handle enter key op
		if (field == "accountId" || field == "costCenterId" || field == "costTafsilId") {
			this.doEnterAfterSelect(rowIndex, columnIndex);
		}
	}
	doEnterAfterSelect(rowIndex, colIndex) {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (colIndex + 1 < colCount) {
			//find first next active input
			if (!row[colIndex + 1]) {
				this.doEnterAfterSelect(rowIndex, colIndex + 1);
			}
			else {
				row[colIndex + 1]?.focus();
				if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
			}
		} else if (rowIndex + 1 < rowCount) {
			if (!this.inputRefs[rowIndex + 1][0]) {
				this.doEnterAfterSelect(rowIndex + 1, 1);
			}
			else {
				this.inputRefs[rowIndex + 1][0]?.focus();
				if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
			}
		}
	}
	updateFormula() {
		var total = 0;

		var hasBlankRow = false;

		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].costCenterId == null)
				hasBlankRow = true;

			if (this.isBlank(this.state.data.record.items[i]['price'])) this.state.data.record.items[i]['price'] = 0;
			total += this.state.data.record.items[i]['price'];
		}

		this.state.data.record.total = total;

		if (!hasBlankRow && this.state.data.record.status === 1) this.addBlankRow();

		this.setState({ date: this.state.data });
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	getLastBodyId() {
		return this.state.data.record.items.sort((a, b) => b.index - a.index)[0].id;
	}
	showDocument(id) {
		this.showComponents({ component: <Document Caller={this} Id={id} /> });
	}
	renderBody() {
		var trs = [];
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach((item, index) => {
			var tds = [];
			var refColumnIndex = 0;

			tds.push(<td>
				<label>{index + 1}</label>
				<div className="d-flex invoice-arrow-container">
					{this.state.data.record.status === 1 && index > 0 &&
						index != this.state.data.record.items.length - 1 && (
							<a onClick={(e) => this.upIndex(item.id)} title="انتقال به بالا">
								<i className="mir-arrow-up2 text-soft-pink "></i>
							</a>
						)}
					{this.state.data.record.status === 1 && index < this.state.data.record.items.length - 2 && (
						<a onClick={(e) => this.downIndex(item.id)} title="انتقال به پایین">
							<i className="mir-arrow-down2 text-color-blue-46"></i>
						</a>
					)}
				</div>
			</td>);

			if (this.state.data.record.status === 1) {
				let _refColumnIndexC1 = refColumnIndex;
				tds.push(<td key={"costCenter_" + item.id + "_" + item.costCenterId}>
					<SelectAsync
						defaultValue={item.costCenterId != null ? [{ value: item.costCenterId, label: item.costCenterName }] : null}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						defaultOptions={[]}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [8, 9])}
						onChange={e => this.setBodyValue(item.id, 'costCenterId', e, index, _refColumnIndexC1)}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC1] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC1];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC1, e);
							}
						}}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.costCenterName}</td>);
			}
			if (this.state.data.record.status === 1) {
				let _refColumnIndexC1 = refColumnIndex;
				tds.push(<td key={"costTafsil_" + item.id + "_" + item.costTafsilId}>
					<SelectAsync
						defaultValue={item.costTafsilId != null ? [{ value: item.costTafsilId, label: item.costTafsilName }] : null}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						defaultOptions={[]}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [6])}
						onChange={e => this.setBodyValue(item.id, 'costTafsilId', e, index, _refColumnIndexC1)}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC1] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC1];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC1, e);
							}
						}}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.costTafsilName}</td>);
			}
			if (this.state.data.record.status === 1) {
				let _refColumnIndexC5 = refColumnIndex;
				tds.push(<td>
					<input type="text" className="form-input text-center"
						defaultValue={item.description}
						onChange={(e) => this.setBodyValue(item.id, 'description', e.target.value)}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC5] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC5, e)}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.description}</td>);
			}
			if (this.state.data.record.status === 1) {
				let _refColumnIndexC8 = refColumnIndex;
				tds.push(<td>
					<NumberFormat
						value={item.price}
						onChange={(e) => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))}
						thousandSeparator={true}
						prefix={''}
						className="form-input text-center ltr"
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC8] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC8, e)}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{this.money(item.price)}</td>);
			}
			if (this.state.data.record.status === 1) {
				let _refColumnIndexC13 = refColumnIndex;
				tds.push(<td key={"account_" + item.id + "_" + item.accountId}>
					<SelectAsync
						isClearable={true}
						defaultValue={
							item.accountId !== null
								? [
									{
										value: item.accountId,
										label: item.accountName,
									},
								]
								: null
						}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						defaultOptions={[]}
						loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [1, 3, 4])}
						onChange={(e) =>
							this.setBodyValue(item.id, 'accountId', e, index, _refColumnIndexC13)
						}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC13] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC13];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC13, e);
							}
						}}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.accountName}</td>);
			}

			if (this.state.data.record.status === 2) {
				tds.push(<td>{item.documentNumber > 0 && <a onClick={e => this.showDocument(item.documentId)} className="text-primary txt-bold hand">{item.documentNumber}</a>}</td>);
			}

			tds.push(<td>
				<div className="item-actions">
					{this.state.data.record.status === 1 && item.costCenterId != null && <button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn">
						<i className="mir-trash text-danger"></i>
					</button>
					}
					{this.state.data.record.status === 1 && item.costCenterId != null && <button title="کپی سطر" onClick={(e) => this.copyRow(item.id)} className="item-copy-btn">
						<img src="assets/images/icons/copy-item-left-bottom.svg" />
					</button>
					}
					{this.state.data.record.status === 2 && item.costCenterId != null && <button onClick={(e) => this.onAllocation(item.id)} className="btn btn-success">تخصیص</button>}
				</div>
			</td>);

			trs.push(<tr key={item.id}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">دفتر هزینه</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								<div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">از تاریخ<span className="red">*</span></label>
										{this.state.enableDatePicker === true ? <DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.fromDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.fromDate)}
										/> :
											<input
												onChange={(e) => this.state.data.record.fromDateString = e.target.value}
												defaultValue={this.state.data.record.fromDateString}
												autoComplete="off"
												placeholder={'تاریخ'}
												type="text"
												className="form-control ltr"
												maxLength="10"
											/>}
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تا تاریخ<span className="red">*</span></label>
										{this.state.enableDatePicker === true ? <DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.toDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.toDate)}
										/> :
											<input
												onChange={(e) => this.state.data.record.toDateString = e.target.value}
												defaultValue={this.state.data.record.toDateString}
												autoComplete="off"
												placeholder={'تاریخ'}
												type="text"
												className="form-control ltr"
												maxLength="10"
											/>}
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">شماره</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
									</div>
								</div>
								<div className="col-md-12">
									<label className="title1">توضیحات</label>
									<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "100%" }} maxlength="150" />
								</div>
							</div>

							{this.state.data.record.type !== 9 && <ul className="nav nav-tabs mt-n3" role="tablist">
								<li className="nav-item" role="presentation">
									<a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>اقلام دفتر</span></a>
								</li>
								{this.state.data.record.id !== this.getDefaultGuid() && <li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab4" aria-selected="false" tabindex="-1" role="tab"><span>گردش کار</span></a>
								</li>}
							</ul>}
							<div className="tab-content">
								<div className="tab-pane active" id="tab1" role="tabpanel">
									<div className="col-lg-12">
										<table className="table table-bordered acc_grid_row">
											<thead>
												<tr className="active">
													<td style={{ "width": "30px" }}>#</td>
													<td style={{ minWidth: "150px" }}>مرکز هزینه</td>
													<td style={{ minWidth: "150px" }}>تفصیل هزینه</td>
													<td>شرح</td>
													<td style={{ "width": "80px" }}>مبلغ<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
													<td style={{ "width": "140px" }}>طرف حساب</td>
													{this.state.data.record.status === 2 && <th style={{ minWidth: '150px' }}><span>سند تخصیص</span></th>}
													<td style={{ "width": "35px" }}></td>
												</tr>
											</thead>
											{this.renderBody()}
										</table>
									</div>
								</div>
							</div>
							{this.state.data.record.id !== this.getDefaultGuid() && <div className="tab-pane" id="tab4" role="tabpanel">
								<WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={53} />
							</div>}

							<div className="row" style={{ "padding-left": "15px" }} >
								<div className="col-lg-9 col-md-12 col-sm-12">
									<div className="form-group" style={{ "padding-left": "50px" }} >
										<label className="title1" for="comment">یادداشت</label>
										{this.state.data.record.status === 1 ? <textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
										: this.state.data.record.note}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							{this.state.data.record.status === 2 && <button type="button" className="hand btn btn-primary" onClick={e => this.onAllocation()} >تخصیص کل دفتر</button>}
							{this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 1)} >ذخیره - پیش نویس</button>}
							{this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 2)} >ذخیره - صدور سند</button>}
							{this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف</a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	setFinalDiscount(e) {
		this.state.data.record.discount = parseFloat(e.target.value.replace(/,/g, ''));
		this.updateFormula();
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}